import { Box, Grid } from '@chakra-ui/react';
import { useAppSelector } from '../../lib/hooks';
import { FilterFolders } from '../../lib/SearchFilter';
import FolderItem from './FolderItem';

export default function FoldersOverviewPage() {
  const searchQueryFolder = useAppSelector(
    (state) => state.viewReducer.documents.search.query.FOLDER,
  );
  const folders = useAppSelector((state) => state.viewReducer.documents.structure.FOLDER);

  const filteredFolders = FilterFolders(Object.values(folders), searchQueryFolder);

  return (
    <Box height="100%" backgroundColor="background" p={2}>
      <Grid
        padding={4}
        style={{
          height: '100%',
          borderRadius: '10px',
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          justifyItems: 'start',
        }}
        templateColumns={'repeat(auto-fit, minmax(380px, 1fr))'}
        gap={4}
      >
        {filteredFolders.map((folder) => (
          <FolderItem key={'page' + folder.id} folder={folder} />
        ))}
      </Grid>
    </Box>
  );
}
